/* The Glow Up Guide — product page interactions (gallery, reveal, sticky ATC).
   Theme-editor safe: re-binds on shopify:section:load; reveals shown in design mode. */
(function () {
  if (window.__gugpProductInit) return;
  window.__gugpProductInit = true;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  if (!designMode) document.documentElement.classList.add('gugp-js');

  function initGallery(root) {
    var main = root.querySelector('.gugp-gallery-main img');
    var mainWrap = root.querySelector('.gugp-gallery-main');
    var thumbs = root.querySelector('.gugp-thumbs');
    if (!main || !mainWrap || mainWrap.dataset.gugpBound) return;
    mainWrap.dataset.gugpBound = '1';

    var lb = root.querySelector('.gugp-lightbox');
    var lbImg = lb ? lb.querySelector('img') : null;
    var count = mainWrap.querySelector('.gugp-gal-count');
    var current = 0;

    // Lightbox pinch-to-zoom state
    var zScale = 1, zTx = 0, zTy = 0;
    function applyZoom() { if (lbImg) lbImg.style.transform = zScale > 1 ? 'translate(' + zTx + 'px,' + zTy + 'px) scale(' + zScale + ')' : ''; }
    function resetZoom() { zScale = 1; zTx = 0; zTy = 0; applyZoom(); }

    function fullsList() {
      if (!thumbs) return [];
      return [].map.call(thumbs.children, function (t) { return t.getAttribute('data-full'); });
    }
    function scrollThumbIntoView() {
      if (!thumbs) return;
      var a = thumbs.children[current]; if (!a) return;
      var tl = a.offsetLeft, tw = a.offsetWidth, sl = thumbs.scrollLeft, vw = thumbs.clientWidth;
      if (tl < sl) thumbs.scrollTo({ left: tl - 8, behavior: 'smooth' });
      else if (tl + tw > sl + vw) thumbs.scrollTo({ left: tl + tw - vw + 8, behavior: 'smooth' });
    }
    function setCurrent(i) {
      var fulls = fullsList();
      if (!fulls.length) return;
      current = (i + fulls.length) % fulls.length;
      if (thumbs) [].forEach.call(thumbs.children, function (c, ci) { c.setAttribute('aria-current', ci === current ? 'true' : 'false'); });
      var full = fulls[current];
      if (full) main.src = full.replace('width=1400', 'width=900');
      if (lb && lb.classList.contains('gugp-open') && lbImg) lbImg.src = full;
      if (count) count.textContent = (current + 1) + ' / ' + fulls.length;
      scrollThumbIntoView();
      resetZoom();
    }

    if (thumbs) {
      thumbs.addEventListener('click', function (e) {
        var t = e.target.closest('.gugp-thumb');
        if (!t) return;
        setCurrent([].indexOf.call(thumbs.children, t));
      });
    }

    // Main-image arrows: navigate the gallery (and don't trigger the lightbox)
    var aPrev = mainWrap.querySelector('.gugp-gallery-arrow.prev');
    var aNext = mainWrap.querySelector('.gugp-gallery-arrow.next');
    if (aPrev) aPrev.addEventListener('click', function (e) { e.stopPropagation(); setCurrent(current - 1); });
    if (aNext) aNext.addEventListener('click', function (e) { e.stopPropagation(); setCurrent(current + 1); });

    // Lightbox: tap main image to view full, fitted to screen
    if (lb && lbImg) {
      mainWrap.addEventListener('click', function () {
        var fulls = fullsList();
        lbImg.src = fulls.length ? fulls[current] : main.src;
        resetZoom();
        lb.classList.add('gugp-open');
      });
      // Close resets the gallery back to the first image.
      var close = function () { lb.classList.remove('gugp-open'); resetZoom(); setCurrent(0); };
      var closeBtn = lb.querySelector('.gugp-lightbox-close');
      var prev = lb.querySelector('.gugp-lightbox-prev');
      var next = lb.querySelector('.gugp-lightbox-next');
      if (closeBtn) closeBtn.addEventListener('click', close);
      if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); setCurrent(current - 1); });
      if (next) next.addEventListener('click', function (e) { e.stopPropagation(); setCurrent(current + 1); });
      var swiped = false;
      lb.addEventListener('click', function (e) { if (e.target === lb && !swiped) close(); });
      document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('gugp-open')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') setCurrent(current - 1);
        if (e.key === 'ArrowRight') setCurrent(current + 1);
      });

      // Touch: pinch-to-zoom, drag-to-pan when zoomed, swipe to change image when not zoomed.
      function touchDist(t) { var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY; return Math.sqrt(dx * dx + dy * dy); }
      var startDist = 0, startScale = 1, panX = 0, panY = 0, baseTx = 0, baseTy = 0, swSX = null, swSY = null;
      lbImg.addEventListener('touchstart', function (e) {
        if (e.touches.length === 2) { startDist = touchDist(e.touches); startScale = zScale; }
        else if (e.touches.length === 1) {
          if (zScale > 1) { panX = e.touches[0].clientX; panY = e.touches[0].clientY; baseTx = zTx; baseTy = zTy; }
          else { swSX = e.touches[0].clientX; swSY = e.touches[0].clientY; swiped = false; }
        }
      }, { passive: false });
      lbImg.addEventListener('touchmove', function (e) {
        if (e.touches.length === 2) {
          e.preventDefault();
          zScale = Math.min(4, Math.max(1, startScale * (touchDist(e.touches) / startDist)));
          applyZoom();
        } else if (e.touches.length === 1 && zScale > 1) {
          e.preventDefault();
          zTx = baseTx + (e.touches[0].clientX - panX);
          zTy = baseTy + (e.touches[0].clientY - panY);
          applyZoom();
        }
      }, { passive: false });
      lbImg.addEventListener('touchend', function (e) {
        if (e.touches.length > 0) return;
        if (zScale <= 1.05) resetZoom();
        if (zScale === 1 && swSX !== null) {
          var ct = e.changedTouches[0], dx = ct.clientX - swSX, dy = ct.clientY - swSY;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { swiped = true; setCurrent(current + (dx < 0 ? 1 : -1)); }
        }
        swSX = null;
      });
      // Mouse drag to change image (desktop)
      var mSX = null, mSY = null;
      lb.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') { mSX = e.clientX; mSY = e.clientY; swiped = false; } });
      lb.addEventListener('pointerup', function (e) {
        if (e.pointerType !== 'mouse' || mSX === null) return;
        var dx = e.clientX - mSX, dy = e.clientY - mSY; mSX = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { swiped = true; setCurrent(current + (dx < 0 ? 1 : -1)); }
      });
    }
  }

  var io = null;
  function initReveals(root) {
    var els = root.querySelectorAll('.gugp-reveal:not(.gugp-in)');
    if (designMode || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('gugp-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('gugp-in'); io.unobserve(e.target); } });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  var stickyBound = false;
  function initSticky(root) {
    var sticky = root.querySelector('.gugp-sticky');
    var atc = root.querySelector('[data-gugp-atc-anchor]');
    var footer = document.querySelector('footer') || document.querySelector('.gugp-final');
    if (!sticky || !atc || !('IntersectionObserver' in window) || stickyBound) return;
    stickyBound = true;
    var pastAtc = false, atEnd = false;
    var upd = function () { sticky.classList.toggle('gugp-show', pastAtc && !atEnd); };
    new IntersectionObserver(function (e) { pastAtc = !e[0].isIntersecting; upd(); }, { threshold: 0 }).observe(atc);
    if (footer) new IntersectionObserver(function (e) { atEnd = e[0].isIntersecting; upd(); }, { threshold: 0.1 }).observe(footer);
  }

  var ATC_HEADERS = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

  // Ensure this variant is in the cart EXACTLY ONCE, without clearing anything else.
  // Adds it if absent; forces quantity back to 1 if it somehow got higher (digital good).
  // Returns a promise; rejects if a cart request fails (callers fall back to a native submit).
  function ensureSingle(id) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var existing = null;
        for (var i = 0; i < items.length; i++) {
          if (String(items[i].id) === String(id)) { existing = items[i]; break; }
        }
        if (existing) {
          if (existing.quantity === 1) return null; // already exactly one
          return fetch('/cart/change.js', {
            method: 'POST', headers: ATC_HEADERS,
            body: JSON.stringify({ id: existing.key, quantity: 1 })
          }).then(function (r) { if (!r.ok) throw new Error('change failed'); });
        }
        return fetch('/cart/add.js', {
          method: 'POST', headers: ATC_HEADERS,
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        }).then(function (r) { if (!r.ok) throw new Error('add failed'); });
      });
  }

  function variantId(btn, form) {
    var idEl = form && form.querySelector('[name="id"]');
    return (idEl && idEl.value) || btn.getAttribute('data-variant');
  }

  // One-click Buy it now: keep this guide in the cart exactly once (keeping anything else
  // already in it, so a customer can buy both guides in one checkout), then go to checkout.
  function initBuyNow(root) {
    root.querySelectorAll('[data-gugp-buynow]').forEach(function (btn) {
      if (btn.dataset.gugpBuynowBound) return;
      btn.dataset.gugpBuynowBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault(); // never let the button submit the form to /cart
        if (designMode) return; // don't redirect inside the theme editor
        var form = btn.closest('form');
        var id = variantId(btn, form);
        var fallback = function () {
          if (form) { form.submit(); }
          else if (btn.getAttribute('data-fallback')) { window.location.href = btn.getAttribute('data-fallback'); }
        };
        if (!id) { fallback(); return; }
        btn.disabled = true;
        btn.classList.add('gugp-loading');
        ensureSingle(id)
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () {
            btn.disabled = false;
            btn.classList.remove('gugp-loading');
            fallback();
          });
      });
    });
  }

  // Add to cart: never create a duplicate. If the guide is already in the cart it stays at
  // quantity 1, then we go to the cart. Falls back to the native form submit on any error.
  function initAddToCart(root) {
    root.querySelectorAll('[data-gugp-atc]').forEach(function (btn) {
      if (btn.dataset.gugpAtcBound) return;
      btn.dataset.gugpAtcBound = '1';
      btn.addEventListener('click', function (e) {
        if (designMode) { e.preventDefault(); return; }
        var form = btn.closest('form');
        var id = variantId(btn, form);
        if (!id) return; // let the native submit handle it
        e.preventDefault();
        btn.disabled = true;
        btn.classList.add('gugp-loading');
        ensureSingle(id)
          .then(function () { window.location.href = '/cart'; })
          .catch(function () {
            btn.disabled = false;
            btn.classList.remove('gugp-loading');
            if (form) form.submit();
          });
      });
    });
  }

  // Live launch-offer countdown. Reads a deadline from [data-gugp-countdown] and writes a
  // "Ends in X days Y hrs" string into [data-gugp-cd]; shows the ended text once it passes.
  function initCountdown(root) {
    root.querySelectorAll('[data-gugp-countdown]').forEach(function (el) {
      if (el.dataset.gugpCdBound) return;
      el.dataset.gugpCdBound = '1';
      var target = new Date(el.getAttribute('data-gugp-countdown')).getTime();
      var out = el.querySelector('[data-gugp-cd]');
      var ended = el.getAttribute('data-gugp-ended') || '';
      if (isNaN(target)) { if (out) out.textContent = ''; return; }
      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          if (out) out.textContent = ended;
          el.classList.add('gugp-urgency--ended');
          return false;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var txt;
        if (d > 0) txt = 'Ends in ' + d + (d === 1 ? ' day ' : ' days ') + h + (h === 1 ? ' hr' : ' hrs');
        else if (h > 0) txt = 'Ends in ' + h + (h === 1 ? ' hr ' : ' hrs ') + m + (m === 1 ? ' min' : ' mins');
        else txt = 'Ends in ' + m + (m === 1 ? ' min' : ' mins');
        if (out) out.textContent = txt;
        return true;
      }
      if (tick() !== false) {
        var iv = setInterval(function () { if (tick() === false) clearInterval(iv); }, 30000);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.gugp').forEach(function (root) {
      initGallery(root);
      initReveals(root);
      initSticky(root);
      initBuyNow(root);
      initAddToCart(root);
      initCountdown(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
